import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ActionConfig } from '../../../interfaces/action-config';
import { TranslateModule } from '@ngx-translate/core';
import { NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'app-row-action',
  standalone:true,
  imports:[TranslateModule,NgFor,NgIf],
  templateUrl: './row-action.component.html',
  styleUrls: ['./row-action.component.scss'],
})
export class RowActionComponent implements OnInit {
  @Input() rowData: Record<string, any> = {};
  @Input() action!: ActionConfig | ((row: Record<string, any>) => ActionConfig);
  @Output() onActionClick: EventEmitter<{ name: string; data: any }> = new EventEmitter();

  preparedActionData!: ActionConfig;

  ngOnInit(): void {
    this.preparedActionData = this.prepareRowAction(this.rowData, this.action);
  }

  onActionClicked(name: string, data: any) {
    this.onActionClick.emit({ name, data });
  }

  generateActionTooltip(
    data: Record<string, any>,
    action: ActionConfig 
  ): string {
    return (
      this.preparedActionData?.customToolip?.(data, action) ??
      (this.preparedActionData?.text || this.preparedActionData?.name)
    );
  }

  prepareRowAction(
    data: Record<string, any>,
    action: ActionConfig | ((row: Record<string, any>) => ActionConfig)
  ): ActionConfig {
    if (typeof action === 'function') return action(data);
    return action;
  }
}
